export default "__VITE_ASSET__WVZXTjdz__"